import { Logger } from '@feature-hub/logger';

function isDebugMode(searchParamString: string): boolean {
  const searchParams = new URLSearchParams(searchParamString);
  const debugMode = searchParams.get('debug');
  return debugMode && debugMode === 'true' ? true : false;
}

function createLogger(): Logger {
  function info(...messages: unknown[]): void {
    if (
      process.env.NODE_ENV !== 'production' ||
      isDebugMode(window.location.search) ||
      isDebugMode(window.location.hash.slice(1))
    ) {
      console.info(...messages);
    }
  }

  function warn(...messages: unknown[]): void {
    if (
      process.env.NODE_ENV !== 'production' ||
      isDebugMode(window.location.search) ||
      isDebugMode(window.location.hash.slice(1))
    ) {
      console.warn(...messages);
    }
  }

  function error(...messages: unknown[]): void {
    console.error(...messages);
  }

  return {
    debug: info,
    error: error,
    info: info,
    trace: info,
    warn: warn,
  };
}

export { createLogger, isDebugMode as __isDebugMode };
